import { makeStyles } from '@barracuda-internal/bds-core'

const commonStyles = {
  display: 'inline-block',
  cursor: 'default'
}

export default makeStyles(theme => ({
  yesNoDialog: {
    ...commonStyles,
    minWidth: 500
  },
  yesNoDialogText: {
    ...commonStyles,
    cursor: 'pointer',
    color: theme.palette.secondary.light
  }
}))
